import { apiRequest } from "./baseApi";
import { parseJsonOrThrow } from "./responseUtils";

const ENDPOINT_STORAGE_KEY = "compasscare_web_push_endpoint";

export function getStoredWebPushEndpoint() {
  try {
    return sessionStorage.getItem(ENDPOINT_STORAGE_KEY);
  } catch (_err) {
    return null;
  }
}

function storeWebPushEndpoint(endpoint) {
  try {
    if (endpoint) sessionStorage.setItem(ENDPOINT_STORAGE_KEY, endpoint);
    else sessionStorage.removeItem(ENDPOINT_STORAGE_KEY);
  } catch (_err) {
    // sessionStorage unavailable in some test envs
  }
}

export async function fetchVapidPublicKey() {
  const res = await apiRequest("/web-push/vapid-public-key", { version: "v3" });
  const data = await parseJsonOrThrow(res, "Web Push VAPID key");
  return data?.publicKey;
}

export async function saveWebPushSubscription(subscription) {
  const json = subscription.toJSON();
  const res = await apiRequest("/web-push/subscription", {
    method: "PUT",
    version: "v3",
    body: {
      endpoint: json.endpoint,
      keys: json.keys,
      channel: "web_app",
    },
  });
  await parseJsonOrThrow(res, "Web Push subscription save");
  storeWebPushEndpoint(json.endpoint);
}

export async function deleteWebPushSubscription(endpoint) {
  const target = endpoint || getStoredWebPushEndpoint();
  if (!target) return;
  try {
    const res = await apiRequest("/web-push/subscription", {
      method: "DELETE",
      version: "v3",
      body: { endpoint: target },
    });
    if (!res.ok && res.status !== 204) {
      await parseJsonOrThrow(res, "Web Push subscription delete");
    }
  } catch (_err) {
    // best-effort on logout
  } finally {
    storeWebPushEndpoint(null);
  }
}

/** Best-effort cleanup before session ends (GMA-1318). */
export function unregisterWebPushOnLogout() {
  const endpoint = getStoredWebPushEndpoint();
  const token = localStorage.getItem("token");
  if (!endpoint || !token) {
    storeWebPushEndpoint(null);
    return Promise.resolve();
  }
  return deleteWebPushSubscription(endpoint);
}
